import { useEffect, useState } from 'react'
import { z } from 'zod'

const VERSION_CHECK_INTERVAL_MS = 60_000
const ClientVersionSchema = z.object({ commitSha: z.string().nullable() })

export default function AppUpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    if (!__APP_COMMIT_SHA__) return

    const check = async () => {
      try {
        const response = await fetch('/api/client-version', { cache: 'no-store' })
        if (!response.ok) return
        const { commitSha } = ClientVersionSchema.parse(await response.json())
        if (commitSha && commitSha !== __APP_COMMIT_SHA__) setUpdateAvailable(true)
      } catch {
        // A failed version check should not interrupt the application.
      }
    }
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') void check()
    }

    void check()
    const interval = window.setInterval(() => { void check() }, VERSION_CHECK_INTERVAL_MS)
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      window.clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  if (!updateAvailable) return null

  return (
    <div className="app-update-banner" role="status" data-testid="app-update-banner">
      <span>A new version of Replay QA is available.</span>
      <button type="button" onClick={() => window.location.reload()}>Refresh to update</button>
    </div>
  )
}
